import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';


export const NotFound = () => (
    <div>
        <Row type='flex' justify='center' align='middle'>
            <Col span={5}>
                <h1>
                    Page not found
                </h1 >
                <h3>
                    Nothing to see here
                </h3>
                <Link to='/'>Take me home</Link>
            </Col>
        </Row>
    </div>
);



// WEBPACK FOOTER //
// ./src/containers/Static/NotFound/index.js